"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_query_1 = require("@tanstack/react-query");
const useDonations = () => {
    const fetchFunc = () => axios.get('/api/get-donations').then((response) => response.data.data);
    return (0, react_query_1.useQuery)({ queryKey: ['get-donations'], queryFn: fetchFunc });
};
exports.default = useDonations;
